import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

export default () => 
  <div className='fadein spinner'>
    <FontAwesomeIcon icon={faSpinner} 
    rotation={90}
    size='5x' fixedWidth color='#3B5998' />
  </div>